import { render } from "./for-payers.vue?vue&type=template&id=b25748da&scoped=true&ts=true"
import script from "./for-payers.vue?vue&type=script&lang=ts"
export * from "./for-payers.vue?vue&type=script&lang=ts"

import "./for-payers.vue?vue&type=style&index=0&id=b25748da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b25748da"]])

export default __exports__